var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.1--Settings---Plan-management---current:-free-example",
    transform: "translate(-529.000000, -1266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(197.000000, 1130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(332.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Photo",
    fill: "#BDA8EE",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1151463,13.9083143 L9.22048476,11.9285432 C8.93985681,11.5861314 8.49922913,11.4369817 8.07976188,11.5424157 C7.66029464,11.6478497 7.3327837,11.9900726 7.23188228,12.4283827 C7.13098086,12.8666927 7.27371867,13.3271136 7.60141033,13.6203476 L10.2998677,16.4520202 C10.5165697,16.676618 10.8099301,16.8018238 11.1151463,16.7999799 C11.4163859,16.7986545 11.7050628,16.6736875 11.9189421,16.4520202 L17.6603408,10.4527139 C17.8777247,10.22742 18,9.92074043 18,9.60081238 C18,9.28088433 17.8777247,8.97420476 17.6603408,8.74891089 C17.2124687,8.28369637 16.4891385,8.28369637 16.0412664,8.74891089 L11.1151463,13.9083143 Z",
    id: "Path",
    fill: "#7450C8",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.614245197d91baecd44d0a64b1879aa7.svg";
export { ForwardRef as ReactComponent };